import type { HomePage } from '../model/HomePage';

export const Tester: HomePage = {
    name: 'Tester',
    widgets: [ 'RecommendationTemplates', 'Apps', 'Automations', 'Runs', 'Actions' ],
    featureFlag: 'HomePage-Tester',
    persona: 'TESTER',
};
